"use strict";

const VISIBLE_CLASS = "visible";

const SELECTORS = {
    MESSAGE: ".js-message",
    MESSAGE_BUTTON: ".js-message__close",
    BODY: "body",
    INNER: ".global-alert__inner",
    CONTAINER: ".global-alert",
    PROMO_BANNER: ".promo-code-banner",
    HEADER: ".global-header"
};

function updateAlertHeight() {
    const container = document.querySelector(SELECTORS.CONTAINER);
    const height = container ? container.offsetHeight : 0;
    document.documentElement.style.setProperty('--global-alerts', `${height}px`);
}

function updatePromoBannerHeight() {
    const banner = document.querySelector(SELECTORS.PROMO_BANNER);
    const height = banner ? banner.offsetHeight : 0;
    document.documentElement.style.setProperty('--global-promo-banner', `${height}px`);
}

function updateHeaderHeight() {
    const header = document.querySelector(SELECTORS.HEADER);
    const height = header ? header.offsetHeight : 0;
    document.documentElement.style.setProperty('--global-header', `${height}px`);
}

function showMessage(elem) {
    document.querySelector(SELECTORS.BODY).classList.add("js-message-active");
    elem.classList.add(VISIBLE_CLASS);
    updateAlertHeight();
}

function hideMessage(elem) {
    document.querySelector(SELECTORS.BODY).classList.remove("js-message-active");
    elem.classList.remove(VISIBLE_CLASS);
    updateAlertHeight();
}

export function init() {
    const messages = document.querySelectorAll(SELECTORS.MESSAGE);

    if (messages.length) {
        messages.forEach(message => {
            const messageId = message.getAttribute("data-message-id");
            const messageStorageKey = "app.message-hidden-" + messageId;
            const messageButton = message.querySelector(SELECTORS.MESSAGE_BUTTON);
            let isHidden;

            try {
                isHidden = localStorage.getItem(messageStorageKey);
            } catch (e) {
                console.warn(e);
            }

            if (!isHidden) {
                showMessage(message);
            }

            messageButton.addEventListener("click", function () {
                hideMessage(message);

                try {
                    localStorage.setItem(messageStorageKey, true);
                } catch (e) {
                    console.warn(e);
                }
            });
        });
    }


    setTimeout(() => {
        updateAlertHeight();
        updatePromoBannerHeight();
        updateHeaderHeight();
    }, 50);

    window.addEventListener('resize', updateHeaderHeight);
}

export default { init }

